// src/themes.js
// Shared x20 family palette. "midnight" is the brand default used across all
// x20 sites (creative, research, social, …) — keep it identical so the family
// looks consistent and there's no flash-of-unstyled-theme on first paint.

export const themes = {
  cyan: {
    primaryColor: "#00BCD4",
    accentColor: "#00838F",
    backgroundColor: "#E0F7FA",
    textColor: "#006064",
    buttonTextColor: "#FFFFFF",
    secondaryColor: "#4DD0E1",
  },
  blue: {
    primaryColor: "#105893",
    accentColor: "#0D4676",
    backgroundColor: "#FCFDFD",
    textColor: "#076dbb",
    buttonTextColor: "#FFFFFF",
    secondaryColor: "#B8CEE0",
  },
  // Mirrors the deployed site-theme.json so first-paint matches the brand.
  midnight: {
    themeName: "Midnight",
    primaryColor: "#5693c2",
    accentColor: "#7e9aae",
    backgroundColor: "#10202c",
    textColor: "#fcfcfd",
    buttonTextColor: "#fcfcfc",
    secondaryColor: "#5d6a74",
  },
};
